import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import '../Login/Index.css'

import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from "react-router-dom";

import { login, triggerAlert, getToken, set_user_menu_permission } from '../../utils';
//import Loader from '../../common/Loader';

export default function Login() {

    const [captchaUrl, setCaptchaUrl] = useState('');
    const [userCaptchaInput, setUserCaptchaInput] = useState('');
    const [isCaptchaValid, setIsCaptchaValid] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const [passwordType, setPasswordType] = useState("password");


    const api_url = process.env.REACT_APP_API_BASE_URL;
    const api_url_cust = process.env.REACT_APP_API_CUSTOMER_URL;

    const { control, register, handleSubmit, formState: { errors }, setValue, getValues } = useForm();

    const navigate = useNavigate();

    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text");
        } else {
            setPasswordType("password");
        }
    };

    const refreshCaptcha = async () => {
        // Add code to refresh the captcha
        //setCaptchaUrl(api_url_cust+`forms/GenerateCaptcha/?${Date.now()}`);
        // console.log(captchaUrl)
        try {
            axios.defaults.headers.common = { 'Authorization': `` }
            const response = await axios.get('apiV1/generate-captcha/');
            if (response.status === 200) {
                const data = await response.data;

                // Set the CAPTCHA text
                setIsCaptchaValid(data.captcha_text);

                // Set the CAPTCHA image by creating a data URL
                setCaptchaUrl(`data:image/png;base64, ${data.image_data}`);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const loginSubmit = async (data) => {
        // console.log(isCaptchaValid);
        // console.log(userCaptchaInput);

        //const userInputMatchesCaptcha = userCaptchaInput !== "";
        //setIsCaptchaValid(userInputMatchesCaptcha);

        setIsLoading(true);
        try {
            const response = await axios.post('apiV1/user/login/', data);
            const response_data = response.data;
            //console.log(response_data.results.token);
            //console.log(response_data.results);
            if (response_data.status == 200) {
                var token = response_data.token.access;
                var user_data = response_data;
                axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }
                // var customer_id = 0;
                // var auth_user = "";
                // var company_name = "";
                var username = "";
                var email = "";
                var user_type = "";
                var admin_id = 0;
                if (user_data) {
                    // auth_user = user_data.user.first_name + " " + user_data.user.last_name;
                    // company_name = user_data.user.company_name;
                    // customer_id = user_data.user.id;
                    username = user_data.name;
                    email = user_data.user.email;
                    user_type = user_data.role_id;
                    admin_id = user_data.user;
                }

                if (token) {
                    if(user_data.role_id){
                        fetchMenuListApi(user_data.role_id)
                        login(token, username, email, user_type, admin_id);
                    }else{
                        setIsLoading(false);
                        triggerAlert('error', 'Oops...', 'Above email dont have role please assign');
                    }
                    
                    //login(token, auth_user, company_name, customer_id);
                    // const admin_token = getToken();
                    // fetchUserMenuPermissionData(admin_token)
                   
                    
                    setIsLoading(false);
                } else {
                    setIsLoading(false);
                    triggerAlert('error', 'Oops...', 'Invalid Login Credentials');
                }
            } else {
                setIsLoading(false);
                triggerAlert('error', 'Oops...', 'Invalid Login Credentials');
            }
        } catch (error) {
            //console.log(error);
            //console.log(error.response.data.message);
            //error.response.status=="Request failed with status code 401"
            if (error?.response?.status == "401") {
                triggerAlert('error', 'Oops...', error.response.data.message);
            } else {
                triggerAlert('error', 'Oops...', 'Invalid Login Credentials');
            }
            setIsLoading(false);
            //triggerAlert('error', 'Oops...', 'Invalid Login..');
            // 
        }

    };
    const fetchMenuListApi = async (role_id) => {

        try {
            const response = await axios.get(`apiV1/module-mappings/?role_id=${role_id}`);
            const response_data = response.data
            if (response.status === 200) {
                const itemsArray = response_data.results;
                sessionStorage.setItem('modulepermissions', JSON.stringify(itemsArray))

                navigate('/dashboard');
            }

        } catch (error) {
            // triggerAlert('error', 'Oops...', 'Something went wrong..');
        }
    };
    const fetchUserMenuPermissionData = async (token) => {

        try {

            const response = await axios.get(api_url + 'get_user_menu_permissions', token);
            const response_data = response.data

            if (response.status === 200) {
                const itemsArray = response_data.results;

                const menu_id_add_array = itemsArray.menu_id_add.split(',').map(Number);
                const menu_id_edit_array = itemsArray.menu_id_edit.split(',').map(Number);
                const menu_id_delete_array = itemsArray.menu_id_delete.split(',').map(Number);
                const excel_export_array = itemsArray.excel_export.split(',').map(Number);

                set_user_menu_permission(menu_id_add_array, menu_id_edit_array, menu_id_delete_array, excel_export_array);

            } else if (response.status === 204) {

            }
            else {
                // triggerAlert('error', 'Oops...', 'Something went wrong here..');
            }

        } catch (error) {
            // triggerAlert('error', 'Oops...', 'Something went wrong..');
        }
    };




    useEffect(() => {
        refreshCaptcha();
    }, []);

    // console.log(getValues());

    return (
        <>
            <div class="auth-page">
                <div class="container-fluid p-0">
                    <div class="row g-0">
                        <div class="col-xxl-4 col-lg-4 col-md-5">
                            <div class="auth-full-page-content d-flex p-sm-5 p-4">
                                <div class="w-100">
                                    <div class="d-flex flex-column h-100 p-5">
                                        <div class=" text-center">
                                            <a href=" " class="d-block auth-logo">
                                                <img src="assets/images/logo.png" alt="" height="70" />
                                            </a>
                                        </div>
                                        <div class="auth-content my-auto">
                                            <div class="text-center">
                                                <h5 class="mb-0">Welcome Back !</h5>
                                                <p class="text-muted mt-2">Sign in to continue to Avatar Chatbots -</p>
                                            </div>
                                            <form id="creditCardForm" key={2} class="row g-3 fv-plugins-bootstrap5 fv-plugins-framework fv-plugins-icon-container" novalidate="novalidate" enctype="multipart/form-data" onSubmit={handleSubmit(loginSubmit)}>
                                                <div class="mb-3">
                                                    <label class="form-label">Email</label>
                                                    <input type="text" name="email" id="email" class="form-control" placeholder="Enter Email" {...register('email', {
                                                        required: 'Email is required',

                                                        pattern: {
                                                            value: /^[0-9+]{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/,
                                                            message: 'Please enter valid email id',
                                                        },
                                                    })} />
                                                    {errors.email && <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errors.email.message}</div>}
                                                </div>
                                                <div class="mb-3">
                                                    <div class="d-flex align-items-start">
                                                        <div class="flex-grow-1">
                                                            <label class="form-label">Password</label>
                                                        </div>
                                                        <div class="flex-shrink-0">
                                                            <div class="">
                                                                {/* <a href=" " class="text-muted">Forgot password?</a> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="input-group auth-pass-inputgroup">
                                                        {/* <input type="password" class="form-control" placeholder="Enter password" aria-label="Password" aria-describedby="password-addon" /> */}
                                                        <Controller
                                                            name="password"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <>
                                                                    <input
                                                                        {...field}
                                                                        type={showPassword ? "text" : "password"} id="password" class="form-control" placeholder="Enter password"  {...register('password', {
                                                                            required: 'Password is required',
                                                                            maxLength: {
                                                                                value: 25,
                                                                                message: 'Max Length Exceeded',
                                                                            },
                                                                            minLength: {
                                                                                value: 6,
                                                                                message: 'Min Length is not Reached',
                                                                            },
                                                                            pattern: {
                                                                                value: /^[a-zA-Z0-9@+-]+$/,
                                                                                message: 'Password should contain numbers, alphabets or special symbols like @+-',
                                                                            },
                                                                        })}
                                                                    //onChange={(e) =>setPassword(e.target.value)}
                                                                    //value={password}
                                                                    // onChange={(e) => {
                                                                    //     field.onChange(e);
                                                                    //     setValue('watch_word', e.target.value); // Set the value of field2
                                                                    // }}
                                                                    />
                                                                    <button class="btn btn-primary shadow-none ms-0" type="button" value={showPassword} onClick={() => setShowPassword((prev) => !prev)} id="password-addon">
                                                                        {showPassword ?
                                                                            (<i class="mdi mdi-eye-outline"></i>) : (<i class="mdi mdi-eye-off-outline"></i>)
                                                                        }
                                                                    </button>
                                                                </>
                                                            )}
                                                        />
                                                    </div>
                                                    {errors.password && <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errors.password.message}</div>}
                                                </div>
                                                <div class="col-md-12">
                                                    <label class="form-label">Verification Code</label>
                                                </div>

                                                <div class="fv-row mb-10   d-flex align-items-center mb-4">
                                                    <div class="col-xs-12 col-sm-12 col-md-8 no-padding">
                                                        <input type="text" className="form-control" id="username"
                                                            placeholder="Verification Code" value={userCaptchaInput} onChange={(e) => setUserCaptchaInput(e.target.value)} />
                                                        {/* <input name="verify_code" type="text" class="form-control ng-pristine ng-invalid ng-invalid-required ng-touched" placeholder="Verification Code" ng-model="formdata.captcha" {...register('verify_code', { required: 'Verification Code is required'})} /> */}
                                                        {/* {errors.verify_code && <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errors.verify_code.message}</div>} */}
                                                    </div>

                                                    <div class="w-auto">
                                                        <img id="vimg" alt='captcha' src={captchaUrl} align="absmiddle" style={{ width: '100px', height: 'auto' }} />
                                                        <svg onClick={refreshCaptcha} className="icon ms-2" height="35"
                                                            viewBox="0 0 24 24" width="35" xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="m23.8995816 10.3992354c0 .1000066-.1004184.1000066-.1004184.2000132 0 0 0 .1000066-.1004184.1000066-.1004184.1000066-.2008369.2000132-.3012553.2000132-.1004184.1000066-.3012552.1000066-.4016736.1000066h-6.0251046c-.6025105 0-1.0041841-.4000264-1.0041841-1.00006592 0-.60003954.4016736-1.00006591 1.0041841-1.00006591h3.5146443l-2.8117154-2.60017136c-.9037657-.90005932-1.9079498-1.50009886-3.0125523-1.90012523-2.0083682-.70004614-4.2175733-.60003954-6.12552305.30001977-2.0083682.90005932-3.41422594 2.50016478-4.11715481 4.5002966-.20083682.50003295-.80334728.80005275-1.30543933.60003954-.50209205-.10000659-.80334728-.70004613-.60251046-1.20007909.90376569-2.60017136 2.71129707-4.60030318 5.12133891-5.70037568 2.41004184-1.20007909 5.12133894-1.30008569 7.63179914-.40002637 1.4058578.50003296 2.7112971 1.30008569 3.7154812 2.40015819l3.0125523 2.70017795v-3.70024386c0-.60003955.4016736-1.00006591 1.0041841-1.00006591s1.0041841.40002636 1.0041841 1.00006591v6.00039545.10000662c0 .1000066 0 .2000132-.1004184.3000197zm-3.1129707 3.7002439c-.5020921-.2000132-1.1046025.1000066-1.3054394.6000396-.4016736 1.1000725-1.0041841 2.200145-1.9079497 3.0001977-1.4058578 1.5000989-3.5146444 2.3001516-5.623431 2.3001516-2.10878662 0-4.11715482-.8000527-5.72384938-2.4001582l-2.81171548-2.6001714h3.51464435c.60251046 0 1.0041841-.4000263 1.0041841-1.0000659 0-.6000395-.40167364-1.0000659-1.0041841-1.0000659h-6.0251046c-.10041841 0-.10041841 0-.20083682 0s-.10041841 0-.20083682 0c0 0-.10041841 0-.10041841.1000066-.10041841 0-.20083682.1000066-.20083682.2000132s0 .1000066-.10041841.1000066c0 .1000066-.10041841.1000066-.10041841.2000132v.2000131.1000066 6.0003955c0 .6000395.40167364 1.0000659 1.0041841 1.0000659s1.0041841-.4000264 1.0041841-1.0000659v-3.7002439l2.91213389 2.8001846c1.80753138 2.0001318 4.31799163 3.0001977 7.02928871 3.0001977 2.7112971 0 5.2217573-1.0000659 7.1297071-2.9001911 1.0041841-1.0000659 1.9079498-2.3001516 2.4100418-3.7002439.1004185-.6000395-.2008368-1.2000791-.7029288-1.3000857z"
                                                                transform=""></path>
                                                        </svg>
                                                        {/* <!-- <i style="color:#00CA00; font-size:20px; cursor:pointer;" class="fas fa-refresh" onClick="javascript:refreshCaptcha()"></i> -->  */}
                                                    </div>
                                                    {/* <span class="mx-3" id="refreshimage" onclick="javascript:refreshCaptcha()">
                                                    <svg width="30px" height="30px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 489.645 489.645" style="enable-background:new 0 0 489.645 489.645" xml:space="preserve"><g><path d="M460.656,132.911c-58.7-122.1-212.2-166.5-331.8-104.1c-9.4,5.2-13.5,16.6-8.3,27c5.2,9.4,16.6,13.5,27,8.3
                                                    c99.9-52,227.4-14.9,276.7,86.3c65.4,134.3-19,236.7-87.4,274.6c-93.1,51.7-211.2,17.4-267.6-70.7l69.3,14.5
                                                    c10.4,2.1,21.8-4.2,23.9-15.6c2.1-10.4-4.2-21.8-15.6-23.9l-122.8-25c-20.6-2-25,16.6-23.9,22.9l15.6,123.8
                                                    c1,10.4,9.4,17.7,19.8,17.7c12.8,0,20.8-12.5,19.8-23.9l-6-50.5c57.4,70.8,170.3,131.2,307.4,68.2
                                                    C414.856,432.511,548.256,314.811,460.656,132.911z"></path></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></span>  */}
                                                </div>
                                                {/* <div class="row mb-4">
                                                    <div class="col">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="checkbox" id="remember-check" />
                                                            <label class="form-check-label" for="remember-check">
                                                                Remember me
                                                            </label>
                                                        </div>  
                                                    </div>
                                                </div> */}
                                                <div class="mb-3">
                                                    <button class="btn btn-primary w-100 waves-effect waves-light" type="submit">Log In</button>
                                                </div>
                                            </form>
                                            {/* <div class="mt-5 text-center">
                                                <p class="text-muted mb-0">Don't have an account ? <a href=" " class="text-primary fw-semibold"> Signup now </a> </p>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- end auth full page content --> */}
                        </div>
                        {/* <!-- end col --> */}
                        <div class="col-xxl-8 col-lg-8 col-md-7">
                            <div class="auth-bg pt-md-5 p-4 d-flex">
                                <div class="bg-overlay bg-primary"></div>
                                <ul class="bg-bubbles">
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                                {/* <!-- end bubble effect --> */}
                                <div class="row justify-content-center align-items-center">
                                    <div class="col-xl-7">
                                        <div class="p-0 p-sm-4 px-xl-0">
                                            <div id="reviewcarouselIndicators" class="carousel slide" data-bs-ride="carousel">
                                                <div class="carousel-indicators carousel-indicators-rounded justify-content-start ms-0 mb-0">
                                                    <button type="button" data-bs-target="#reviewcarouselIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                                    <button type="button" data-bs-target="#reviewcarouselIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                                    <button type="button" data-bs-target="#reviewcarouselIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                                </div>
                                                {/* <!-- end carouselIndicators --> */}
                                                <div class="carousel-inner">
                                                    <div class="carousel-item active">
                                                        <div class="testi-contain text-white">
                                                            <i class="bx bxs-quote-alt-left text-success display-6"></i>

                                                            <h4 class="mt-4 fw-medium lh-base text-white">“I feel confident
                                                                imposing change
                                                                on myself. It's a lot more progressing fun than looking back.
                                                                That's why
                                                                I ultricies enim
                                                                at malesuada nibh diam on tortor neaded to throw curve balls.”
                                                            </h4>
                                                            <div class="mt-4 pt-3 pb-5">
                                                                <div class="d-flex align-items-start">
                                                                    <div class="flex-shrink-0">
                                                                        <img src="assets/images/users/avatar-1.jpg" class="avatar-md img-fluid rounded-circle" alt="..." />
                                                                    </div>
                                                                    <div class="flex-grow-1 ms-3 mb-4">
                                                                        <h5 class="font-size-18 text-white">Satheesh
                                                                        </h5>
                                                                        <p class="mb-0 text-white-50">Php developer</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="carousel-item">
                                                        <div class="testi-contain text-white">
                                                            <i class="bx bxs-quote-alt-left text-success display-6"></i>

                                                            <h4 class="mt-4 fw-medium lh-base text-white">“Our task must be to
                                                                free ourselves by widening our circle of compassion to embrace
                                                                all living
                                                                creatures and
                                                                the whole of quis consectetur nunc sit amet semper justo. nature
                                                                and its beauty.”</h4>
                                                            <div class="mt-4 pt-3 pb-5">
                                                                <div class="d-flex align-items-start">
                                                                    <div class="flex-shrink-0">
                                                                        <img src="assets/images/users/avatar-1.jpg" class="avatar-md img-fluid rounded-circle" alt="..." />
                                                                    </div>
                                                                    <div class="flex-grow-1 ms-3 mb-4">
                                                                        <h5 class="font-size-18 text-white">Chaitanya
                                                                        </h5>
                                                                        <p class="mb-0 text-white-50">Business Analyst</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="carousel-item">
                                                        <div class="testi-contain text-white">
                                                            <i class="bx bxs-quote-alt-left text-success display-6"></i>

                                                            <h4 class="mt-4 fw-medium lh-base text-white">“I've learned that
                                                                people will forget what you said, people will forget what you
                                                                did,
                                                                but people will never forget
                                                                how donec in efficitur lectus, nec lobortis metus you made them
                                                                feel.”</h4>
                                                            <div class="mt-4 pt-3 pb-5">
                                                                <div class="d-flex align-items-start">
                                                                    <img src="assets/images/users/avatar-3.jpg"
                                                                        class="avatar-md img-fluid rounded-circle" alt="..." />
                                                                    <div class="flex-1 ms-3 mb-4">
                                                                        <h5 class="font-size-18 text-white">Sunitha</h5>
                                                                        <p class="mb-0 text-white-50">Sr.Manager
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <!-- end carousel-inner --> */}
                                            </div>
                                            {/* <!-- end review carousel --> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- end col --> */}
                    </div>
                    {/* <!-- end row --> */}
                </div>
                {/* <!-- end container fluid --> */}
            </div>
        </>
    );
};
